import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Enum defining possible animation directions for dialog entrances
 */
export enum DialogEntryDirection {
    None = 'none',
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

/**
 * Options for dialog animations
 */
export interface DialogAnimationOptions {
    /** The direction from which the dialog should enter */
    direction?: DialogEntryDirection;
}

/**
 * Extended MatDialogConfig that includes animation options
 */
export interface ExtendedMatDialogConfig<D = any> extends MatDialogConfig<D> {
    /** Animation configuration for dialog entrance */
    animation?: DialogAnimationOptions;
}
